import { Injectable } from '@angular/core';

const ACCESSTOKEN = 'AccessToken';

@Injectable({
  providedIn: 'root',
})
export class AuthCedentialsService {
  setToken(token: string): void {
    localStorage.setItem(ACCESSTOKEN, token);
  }

  getToken(): string {
    return localStorage.getItem(ACCESSTOKEN);
  }

  hasToken(): boolean {
    return !!localStorage.getItem(ACCESSTOKEN);
  }

  removeToken(): void {
    localStorage.removeItem(ACCESSTOKEN);
  }
}
